// Load the componetns after the polyfill is importned and enabled
import('@webcomponents/webcomponentsjs/webcomponents-bundle.js').then(async () => {
    await import('./web-components/wizard-embed/index');
});
